// extracted by mini-css-extract-plugin
module.exports = {"boxart":"style_boxart__1xGFU","info":"style_info__3Hxqv"};